import DeviceChoice from './../src/device-choice/support.js'
window.deviceChoice = new DeviceChoice()
